import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "update-banner" }
const _hoisted_2 = {
  class: "flex min-h-screen",
  style: {"background":"#0f1419"}
}
const _hoisted_3 = { class: "app-main-content" }
const _hoisted_4 = { class: "app-topbar" }
const _hoisted_5 = { class: "app-page-content" }
const _hoisted_6 = { class: "login-container" }
const _hoisted_7 = { class: "login-card" }
const _hoisted_8 = { class: "login-header" }
const _hoisted_9 = { style: {"font-size":"2rem","padding":"0","margin":"0"} }
const _hoisted_10 = { class: "login-subtitle" }
const _hoisted_11 = { class: "login-form" }
const _hoisted_12 = { class: "login-field" }
const _hoisted_13 = { class: "login-label" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "login-field" }
const _hoisted_16 = { class: "login-label" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "login-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMenuAkahon = _resolveComponent("SidebarMenuAkahon")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshApp && _ctx.refreshApp(...args))),
        class: "update-banner-btn"
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bx bx-refresh" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('app.updateAvailable')), 1)
      ])
    ], 512), [
      [_vShow, $setup.user.updateExists]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SidebarMenuAkahon),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppHeader)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view)
        ], 512), [
          [_vShow, $setup.user.isAuthenticated]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "login-accent-line" }, null, -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('app.signIn')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('app.accessWorkspace')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('i18n.username')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.email) = $event)),
                  type: "text",
                  class: "tap-input",
                  placeholder: _ctx.$t('app.emailPlaceholder')
                }, null, 8, _hoisted_14), [
                  [_vModelText, $data.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('i18n.password')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.password) = $event)),
                  type: "password",
                  class: "tap-input",
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => ($setup.user.userLogin($data.email,$data.password)), ["enter"])),
                  placeholder: _ctx.$t('app.passwordPlaceholder')
                }, null, 40, _hoisted_17), [
                  [_vModelText, $data.password]
                ])
              ]),
              _createElementVNode("button", {
                class: "login-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.user.userLogin($data.email,$data.password)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('i18n.login.login')) + " ", 1),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bx bx-right-arrow-alt" }, null, -1))
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bx bx-error-circle" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.login.error')), 1)
              ], 512), [
                [_vShow, $setup.user.errors.length != 0]
              ])
            ])
          ])
        ], 512), [
          [_vShow, !$setup.user.isAuthenticated]
        ])
      ])
    ])
  ], 64))
}